module.exports = __webpack_public_path__ + "0dff5493711a6adad90d0da2ce1333cd.svg";